import { FieldDisplayType } from "@/pages/settings/components/dealsSettings/FieldManagement/types";
import { EntityType } from "@/services/hooks/entities/useEntityType";
import { TFunction } from "i18next";

export const getEntityTypeFromDisplayType = (
  displayType: string
): EntityType | null => {
  switch (displayType) {
    case FieldDisplayType.USERS:
      return EntityType.USER;
    case FieldDisplayType.COMPANIES:
      return EntityType.COMPANY;
    case FieldDisplayType.PEOPLE:
      return EntityType.PERSON;
    case FieldDisplayType.DEALS:
      return EntityType.DEAL;
    case FieldDisplayType.LEADS:
      return EntityType.LEAD;
    case FieldDisplayType.PARTNERS:
      return EntityType.PARTNER;
    case FieldDisplayType.PARTNER_CONTACTS:
      return EntityType.PARTNER_CONTACT;
    default:
      return null;
  }
};

export const isEntityDisplayType = (displayType: string): boolean => {
  return [
    FieldDisplayType.USERS,
    FieldDisplayType.COMPANIES,
    FieldDisplayType.PEOPLE,
    FieldDisplayType.DEALS,
    FieldDisplayType.LEADS,
    FieldDisplayType.PARTNERS,
    FieldDisplayType.PARTNER_CONTACTS,
    FieldDisplayType.PRODUCTS,
    FieldDisplayType.LICENSES
  ].includes(displayType as FieldDisplayType);
};

export const isProductsDisplayType = (displayType: string): boolean => {
  return displayType === FieldDisplayType.PRODUCTS;
};

export const isLicensesDisplayType = (displayType: string): boolean => {
  return displayType === FieldDisplayType.LICENSES;
};

export const isPeopleDisplayType = (displayType: string): boolean => {
  return displayType === FieldDisplayType.PEOPLE;
};

export const getCreateNewLabel = (
  displayType: string,
  t: TFunction
): string => {
  switch (displayType) {
    case FieldDisplayType.COMPANIES:
      return t("common.addNewCompany");
    case FieldDisplayType.PEOPLE:
      return t("common.addNewPerson");
    case FieldDisplayType.USERS:
      return t("common.addNewUser");
    case FieldDisplayType.DEALS:
      return t("common.addNewDeal");
    case FieldDisplayType.LEADS:
      return t("common.addNewLead");
    case FieldDisplayType.PRODUCTS:
      return t("common.addNewProduct");
    case FieldDisplayType.LICENSES:
      return t("common.addNewLicense");
    case FieldDisplayType.PARTNERS:
      return t("common.addNewPartner");
    case FieldDisplayType.PARTNER_CONTACTS:
      return t("common.addNewPartnerContact");
    default:
      return "Add new";
  }
};
